const REAPPRAISAL_RATIONALE_STATUS_TYPE = {
  PENDING_REVIEW: 0,
  APPROVED: 1,
  RETURNED: 2
};

export default REAPPRAISAL_RATIONALE_STATUS_TYPE;
